








//import AppLayout from "./components/AppLayout";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class App extends Vue {}
